// extracted by mini-css-extract-plugin
export default {"dashHome":"Main_dashHome__wqXN3","titleMainSubH3":"Main_titleMainSubH3__oF62-","blackFocus":"Main_blackFocus__E5U2d","featureListWrapper":"Main_featureListWrapper__X5siq"};